import script from "./word-remote.vue?vue&type=script&setup=true&lang=ts"
export * from "./word-remote.vue?vue&type=script&setup=true&lang=ts"

import "./word-remote.vue?vue&type=style&index=0&id=be22e1e6&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-be22e1e6"]])

export default __exports__